<template>
  <cs-preloader-overlay :loading="loading">
    <subscription-empty-list v-if="isEmpty" />

    <div v-else class="capusta-container">
      <div class="header-container">
        <subscriptions-header />

        <!-- TODO: заменить на компонент и перенести в SubscriptionsHeader -->
        <div v-if="periodicRecurrentPaymentPermission" class="bill-created">
          <a class="button thin action" @click="onRouteSubscription">
            <span>{{ $t('organize.subscription') }}</span>
          </a>
        </div>
      </div>

      <subscription-filter ref="SubscriptionFilters" />

      <subscriptions-groups
        :subscriptions-groups="preparedByGroupSubscriptions"
        @unfollow="onShownUnfollowDialog"
      />

      <cs-dialog v-model="isShownConfirmationUnfollowing">
        <dialog-default-layout>
          <h2 slot="title">{{ $t('you.want.unsubscribe.for.this.user') }}</h2>
          <div slot="footer" class="confirmation-unfollowing-controls">
            <cs-button @click="onUnfollow">{{ $t('common.yes') }}</cs-button>
            <cs-button type="transparent" @click="onCloseDialogUnfollow">{{ $t('common.cancel') }}</cs-button>
          </div>
        </dialog-default-layout>
      </cs-dialog>
    </div>
  </cs-preloader-overlay>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import { formatDateToCustomDateFormat } from 'lib/utils/date';

import logrocket from '@/services/logrocket';

import SubscriptionsHeader from '@/pages/subscriptions/components/SubscriptionsHeader';
import SubscriptionsGroups from '@/pages/subscriptions/components/SubscriptionsGroups';
import SubscriptionEmptyList from '@/pages/subscriptions/components/SubscriptionEmptyList';
import SubscriptionFilter from '@/pages/subscriptions/components/SubscriptionFilter';

import DialogDefaultLayout from 'modules/Dialogs/DefaultLayout';

import SubscriptionCard from './classes/SubscriptionCard';

import { INVOICING } from '@/router/const';

export default {
  name: 'SubscriptionListLayout',
  components: {
    SubscriptionsHeader,
    SubscriptionsGroups,
    SubscriptionEmptyList,
    SubscriptionFilter,
    DialogDefaultLayout,
  },
  async created() {
    await this.loadData();
  },
  mounted() {
    window.addEventListener('scroll', this.cabinetScrollHandler);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.cabinetScrollHandler);
  },
  data() {
    return {
      loading: false,
      isEmpty: true,
      unfollowingById: null,
      isShownConfirmationUnfollowing: false,
    };
  },
  computed: {
    preparedByGroupSubscriptions() {
      const groupedByDate = {};

      this.SUBSCRIPTION_LIST.forEach(data => {
        const subscription = new SubscriptionCard(data);
        const keyToGroup = formatDateToCustomDateFormat(subscription.createdAt, 'DD.MM.YYYY');

        groupedByDate[keyToGroup] = groupedByDate[keyToGroup] || [];
        groupedByDate[keyToGroup].push(subscription);
      });

      return groupedByDate;
    },
    ...mapState(['SUBSCRIPTIONS']),
    ...mapGetters(['SUBSCRIPTION_LIST', 'periodicRecurrentPaymentPermission']),
  },
  watch: {
    isShownConfirmationUnfollowing: {
      handler(val) {
        if (!val) {
          this.unfollowingById = null;
        }
      },
    },
  },
  methods: {
    async loadData() {
      this.loading = true;

      this.SET_SUBSCRIPTIONS_PARAMS({
        filterBy: 'ALL',
        searchText: '',
      });

      await this.GET_SUBSCRIPTIONS({
        page: 1,
        reset: true,
      });

      this.isEmpty = this.$validate.isEmptyArray(this.SUBSCRIPTION_LIST) && this.SUBSCRIPTIONS.checkEmpty;
      this.loading = false;
    },
    onRouteSubscription() {
      this.$router.push({ name: INVOICING, hash: '#subscription' });
    },
    cabinetScrollHandler() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset || 0;
      let offset = scrollTop + window.innerHeight;
      let height = document.documentElement.offsetHeight;

      // load and push transactions when reaches bottom
      let heightFactor = 100;
      if (offset + heightFactor >= height && !this.SUBSCRIPTIONS.loading) {
        this.GET_SUBSCRIPTIONS_AFTER_SCROLLING();
      }

      // filters block
      let arrangerRect = this.$refs.SubscriptionFilters.$refs.arranger.getBoundingClientRect();
      let arrangerOffset = arrangerRect.top;

      this.SET_SCROLL_STATES({
        type: 'Filters_block_is_fixed',
        params: arrangerOffset <= 5,
      });
    },
    onShownUnfollowDialog(subscriptionId) {
      this.unfollowingById = subscriptionId;
      this.isShownConfirmationUnfollowing = true;
    },
    onCloseDialogUnfollow() {
      this.unfollowingById = null;
      this.isShownConfirmationUnfollowing = false;
    },
    async onUnfollow() {
      try {
        await this.UNFOLLOW_SUBSCRIPTION(this.unfollowingById);
      } catch (error) {
        logrocket.logger(error);
      }

      await this.$nextTick();
      this.onCloseDialogUnfollow();
    },
    ...mapActions(['GET_SUBSCRIPTIONS', 'GET_SUBSCRIPTIONS_AFTER_SCROLLING', 'UNFOLLOW_SUBSCRIPTION']),
    ...mapMutations(['SET_SUBSCRIPTIONS_PARAMS', 'SET_SCROLL_STATES']),
  },
};
</script>

<style lang="sass" scoped>
  .confirmation-unfollowing-controls
    display: flex
    justify-content: space-between
    padding-top: 20px

  .capusta-container
    width: 100%
    position: relative
    margin: 0 auto
    display: flex
    flex-direction: column
    padding: 20px 0 60px

    +respond-to('small')
      width: 480px
      padding: 60px 0

  .header-container
    margin-bottom: 20px
    padding: 0 20px

    +respond-to('small')
      padding: 0

  .list_header
   margin-bottom: 5vh
   height: 40px

  .bill-created
    display: none
    background: linear-gradient(241.39deg, #D650D3 -0.37%, #9B51E0 96%)
    box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)
    border-radius: 100px
    line-height: 20px

    @media (max-width: 767px)
      display: block
      position: fixed !important
      right: 1.48rem
      bottom: 1.55rem
      z-index: 10
      width: 60px
      height: 60px
      overflow: hidden
      margin-top: 2px

      &::after
        content: '+'
        color: #fff
        +full-size(0, absolute)
        font-size: 3rem
        display: flex
        justify-content: center
        align-items: center
        pointer-events: none

      a
        &.button
          opacity: 0
</style>
